<ng-template #cellRendererTmpl let-record="record" let-column="column">
  <!-- uncomment to have compiler check template types
  <ng-container *ngIf="typedRecord(record); let record">
    <ng-container *ngIf="typedColumn(column); let column">
  -->

  <ng-container *ngIf="typedRecord(record); let record">
    <ng-container *ngIf="typedColumn(column); let column">
      <ng-container [ngSwitch]="column.name">
        <ng-container *ngLet="taskPointsTable.scoutInfoByRecId[record.id] as scoutInfo">
        <td *ngSwitchCase="'modifiedAtText'">
          <div>
            {{ record.modifiedAtText | date: "yyyy-MM-dd HH:mm:ss" }}
          </div>
          <div class="text-secondary font-italic small">
            {{ record.modifiedByName }}
          </div>
        </td>

        <td *ngSwitchCase="'locationDescription'">
          <div class="p-cell">
            {{ record.locationDescription }}
          </div>
        </td>

        <td *ngSwitchCase="'floorAndDescript'">
          <div class="p-cell">
            {{ record.floorAndDescript }}
          </div>
        </td>

        <td *ngSwitchCase="'buildingId'">
          <a
            href="javascript:false"
            (click)="taskPointsTable.showBuilding(record)"
            >{{ record.buildingId }}</a
          >
        </td>

        <td *ngSwitchCase="'taskId'" class="text-center">
          <a href="javascript:false"
            (click)="taskPointsTable.showTab('volunteer task',''+record.taskId)">{{
            record.taskId
          }}</a>
        </td>

        <td *ngSwitchCase="'pathId'">
          <a href="javascript:false" (click)="showPath(record)">{{
            record.pathId
          }}</a>
        </td>

        <td *ngSwitchCase="'buildingName'">
          <a
            href="javascript:false"
            (click)="taskPointsTable.showBuilding(record)"
            >{{ record.buildingName }}</a
          >
        </td>

        <td *ngSwitchCase="'pointId'">
          <a
            href="javascript:false"
            (click)="task ? onTaskPointIdClick(record) :
              taskPointsTable.showVolunteerPoint({taskId: record.taskId, taskPointId: record.id})"
            [attr.class]="selectedRec?.id === record.id && 'selected-pt'"
            [attr.style]="
              selectedRec?.id === record.id &&
              'border-color: ' + (selectedMapPoint?.color || 'blue')
            "
            >{{ record.pointId }}
          </a>
          <div *ngIf="record.commonName" class="text-secondary small font-italic">{{record.commonName}}</div>
          <div
            class="text-danger font-italic"
            title="Check available points for volunteer"
            *ngIf="record.deleted"
          >
            <i class="fa fa-exclamation-triangle mr-2"></i>Unavailable
          </div>
        </td>
        <td *ngSwitchCase="'pointIdQr'">
          <div id="{{record.pointId}}-QR">
            <app-point-qr-code [pointId]="record.pointId"  #myQrCodecomp></app-point-qr-code>
          </div>
          <button printSectionId="{{record.pointId}}-QR" [useExistingCss]="true" ngxPrint class="btn btn-secondary btn-sm" >Print</button>
        </td>
        <td *ngSwitchCase="'callsPlacedCnt'" class="text-center">
          {{record.callsPlacedCnt}}<ng-container *ngIf="record.targetCallCnt">/{{record.targetCallCnt}}</ng-container>
        </td>
        <!--
        <td *ngSwitchCase="'status'" class="text-center" [ngClass]="record.status|taskStatusCss">
          {{record.status|taskStatusName|titlecase}}
        </td>
        -->
        <td *ngSwitchCase="'statusName'" class="text-center" [ngClass]="record.status|taskStatusCss">
          <div *ngIf="taskPointsTable.savingTaskPointId==record.id" class="text-center">
            <i class="fa fa-spinner fa-spin mr-2" ></i>
            <span class="font-italic text-secondary">saving...</span>
          </div>
          <select id="status-select" class="text-center align-middle m-0 py-3 border-none"
            [disabled]="record.status===PointStatus.Id.NOT_USING&&scoutInfo?.scoutPoint&&scoutInfo.scoutPoint.disabled"
              *ngIf="record" [ngModel]="record.status"
              [ngClass]="taskPointsTable.savingTaskPointId==record.id?'d-none':record.status|taskStatusCss"
              (change)="taskPointsTable.onTaskPointStatusEdited(record,$event)">
            <option class="status-not-started-text" 
              [hidden]="scoutInfo?.scoutPoint?.disabled&&record.status!==PointStatus.Id.NOT_STARTED"               
              [value]="PointStatus.Id.NOT_STARTED">
              Not Started
            </option>
            <option class="status-in-progress-text" 
            [hidden]="scoutInfo?.scoutPoint?.disabled&&record.status!==PointStatus.Id.IN_PROGRESS"               
            [value]="PointStatus.Id.IN_PROGRESS">
              In Progress
            </option>
            <option class="status-approved-text" 
              [hidden]="scoutInfo?.scoutPoint?.disabled&&record.status!==PointStatus.Id.COMPLETE"               
              [value]="PointStatus.Id.COMPLETE">
              Complete
            </option>
            <option class="status-field-complete-text" 
              [hidden]="scoutInfo?.scoutPoint?.disabled&&record.status!==PointStatus.Id.FIELD_COMPLETE"               
              [value]="PointStatus.Id.FIELD_COMPLETE">
              Field Complete
            </option>
            <option class="status-review-complete-text"
              [hidden]="!this.roleMgr.canEditUsers"               
              [value]="PointStatus.Id.REVIEW_COMPLETE">
              Review Complete
            </option>
            <option class="status-not-using-text" 
              [hidden]="!this.roleMgr.canEditUsers" 
              [value]="PointStatus.Id.NOT_USING">
              Not Using
            </option>
            <option class="status-archived-text"
              [hidden]="!this.roleMgr.canEditUsers"
              [value]="PointStatus.Id.ARCHIVED">
              Archived
            </option>
          </select>
        </td>
        <!-- did not find a cell renderer by record name so now try template type -->
        <ng-container *ngSwitchDefault [ngSwitch]="column.template">          
          <td *ngSwitchCase="'scout-point'" class="text-center">
              <app-scout-point-photo-links
                *ngIf="scoutInfo?.scoutPoint"
                [uiLocked]="true"
                [scoutPoint]="scoutInfo.scoutPoint"
                [bShowPhotoSummary]="true"
                [scoutTask]="scoutInfo.scout"
                [scoutPath]="scoutInfo.scoutPath"
                [photoBtnContentTmplRef]="photoBtnContentTmpl"
                [bindContextFn]="bindMobilePhotoContextForTaskPoint(record)"
                (photoIconDblClick)="toggleMobilePhotoForTaskPoint(record)($event)"
              ></app-scout-point-photo-links>
              <ng-template #photoBtnContentTmpl let-photo="photo" let-grpDef="grpDef" let-context="context">
                <i class="fa" [ngClass]="context?.iconCssClass"
                  [ngStyle]="{'background-color': 'rgb(255,255,0,'+photo['bgAlpha']+')'}"></i>
              </ng-template>
          </td>

          <td *ngSwitchCase="'edit-point'" class="text-center">
            <div
              *ngIf="record.deleted"
              class="text-secondary font-italic text-wrap sm small"
            >
              Unavailable Point
            </div>
            <ng-container *ngIf="!record.deleted">
              <div *ngIf="scoutInfo?.scoutPoint&&scoutInfo.scoutPoint.disabled; else scoutPointEnabled"
              class="text-secondary font-italic text-wrap sm small">
              Disabled Scout Point
              </div>
              <ng-template #scoutPointEnabled>
              <button
              *ngIf="!record.deleted"
              [disabled]="tempHack || readonly"
              (click)="task ? onTaskPointEditClick(record) :
                taskPointsTable.showVolunteerPoint({taskId: record.taskId, taskPointId: record.id})"
              class="btn btn-link font-italic"
            >
              edit
            </button>
            </ng-template>
            </ng-container>
          </td>
          <td
            *ngSwitchDefault
            fes-table-view-default-cell-renderer
            [column]="column"
            [record]="record"
            [tableComponent]="taskPointsTable"
          ></td>
        </ng-container>
        </ng-container>
      </ng-container> </ng-container
  ></ng-container>
</ng-template>

<ng-template #editColumnHeaderTmplRef let-table="table" let-column="column">
  <th>
    <div
          *ngIf="table.bulkRowActions?.length && table.checkedRecs.length > 0"
          class="d-flex flex-row ml-1"
        >
          <fes-table-view-action-picker
            (isProcessing)="table.isBulkActionProcessing = $event"
            [rowActions]="table.bulkRowActions"
            [recs]="table.checkedRecs"
            [table]="table"
          >
          </fes-table-view-action-picker>
        </div>
  </th>
</ng-template>
<app-volunteer-task-points-table
  [taskId]="task?.id"
  [editColumnHeaderTmplRef]="editColumnHeaderTmplRef"
  [cellRendererTmplRef]="cellRendererTmpl"
  [tabConfig]="tabConfig"
  [isActiveView]="tabConfig ? tabConfig.active : true"
  [contextJson]="localContext || tabConfig?.viewInfo.id"
  (contextJsonChange)="contextJsonChangeHandler?.($event, tabConfig)"
  [stage]="stage"
  [loadTrigger]="loadTrigger"
  (recordsLoaded)="onTaskPointsChanged($event)"
  #taskPointsTable
>
  <div footerButtonRow class="d-flex flex-row justify-content-between w-100">
    <div class="px-2 font-italic text-secondary">
      <ng-container *ngIf="lastCallTime">Last call {{lastCallTime|date: "yyyy-MM-dd HH:mm"}}
      </ng-container>
    </div>
    <div *ngIf="task">
      <a href="javascript:false;" class="mx-2" (click)="onShowRutLog()">
        Calls
      </a>
      <button
        class="btn btn-secondary btn-sm"
        style="font:caption"
        [printStyle]="{body: {'width': '8.5in;', 'height': '11in'}}"
        printSectionId="labelGrid{{task.id}}"
        ngxPrint
      >
        Print QR Codes
      </button>
    </div>
  </div>
</app-volunteer-task-points-table>

<!-- hidden for rendering QR codes and used by printQrCodes() above -->
<div hidden="true" *ngIf="task?.id">
  <div id="labelGrid{{task.id}}" style="position: absolute; margin-top: 0.625in;">
    <div style="
    margin-left: 0.5in;
    border-bottom-width: 0;
    border-left-width: 0;
    border-top-width: 0;
    border-right-width: 0;
    display: grid;
    grid-auto-flow: row;
    grid-template-columns: repeat(4, 1.5in );
    grid-template-rows: repeat(5, 1.5in );
    column-gap: 0.5in;
    grid-row-gap: 0.5625in;
    "
    >
      <ng-container *ngFor="let record of taskPointsTable.records; index as index">
        <ng-container *ngLet="taskPointsTable.scoutInfoByRecId[record.id] as scoutInfo">
      <div *ngIf="!(scoutInfo?.scoutPoint&&scoutInfo?.scoutPoint.disabled)&&!(notPrintableQrByPtStatus[record.status])"
        [ngClass]="{ selected: record['_is_selected'] }"
        style="
        height: 1.5in;
        width:  1.5in;
        padding: 8px 0 0 0;
        text-align: center;
        vertical-align: middle;
        border: solid;"
        >
          <app-point-qr-code [pointId]="record['pointId']"></app-point-qr-code>
          <p style="
          font-size: smaller;
          margin: 0;
          padding: 4px 0 0 0;
          ">{{record['pointId']}}</p>
        </div>
      </ng-container>
    </ng-container>
    </div>
  </div>
</div>

<ng-content></ng-content>
